import React from 'react';

const WalletIcon = ({ size = 20, color, className, style }) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 42.62 37.73'
    fill='currentColor'
    width={size}
    height={size}
    className={className}
    style={color ? { color, ...style } : style}
    aria-hidden='true'>
    <path d='M42.62,24.04c0,1.83-1.21,3.32-2.84,3.98l-.03,1.75c-.07,4.47-3.97,7.94-8.43,7.95l-22.72.02C4.04,37.73,0,34.2,0,29.53V8.19C0,3.57,4.04-.07,8.58.02L26.8,0c4.27,0,7.94,2.97,8.56,7.22,2.54,1.39,4.35,3.96,4.38,6.85l.02,1.8c1.64.65,2.85,2.17,2.85,3.98v4.18ZM31.5,6.18l.93.05c-.87-2.02-2.8-3.59-5.07-3.6l-18.65-.06c-3.36-.01-6.2,2.51-6.15,5.98,1.63-1.53,3.65-2.37,5.86-2.37h23.08ZM37.18,28.31h-3.45c-3.5-.02-6.22-3.05-6.15-6.49.07-3.45,2.9-6.23,6.4-6.23h3.2c0-.45.02-.77,0-1.24-.14-2.96-2.59-5.56-5.65-5.56H8.26c-3.02,0-5.68,2.55-5.68,5.58v15.19c0,2.91,2.59,5.53,5.54,5.53h23.57c3.03-.01,5.49-2.78,5.49-5.64v-1.14ZM40.03,24.03v-4.11c0-.97-.82-1.75-1.77-1.75h-4.35c-2.08,0-3.72,1.7-3.74,3.73s1.58,3.8,3.67,3.81h4.35c.92.01,1.84-.68,1.84-1.68Z' />
    <path d='M15.42,16.36h-6.52c-.77,0-1.34-.6-1.33-1.3s.58-1.29,1.35-1.29h6.59c.73,0,1.24.64,1.25,1.29,0,.7-.54,1.31-1.33,1.31Z' />
  </svg>
);

export default WalletIcon;
